// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Css from "bs-css-emotion/src/Css.bs.js";
import * as Curry from "rescript/lib/es6/curry.js";
import * as React from "react";
import * as I18next$LiveRoom from "../../bindings/I18next.bs.js";
import * as SterlingIcons$LiveRoom from "../../bindings/SterlingIcons.bs.js";
import * as SterlingTokens$LiveRoom from "../../bindings/SterlingTokens.bs.js";
import * as SterlingTypography$LiveRoom from "../../bindings/SterlingTypography.bs.js";

function LiveStreamThumbnail(props) {
  var className = props.className;
  var className$1 = className !== undefined ? className : "";
  var match = I18next$LiveRoom.useTranslation(undefined);
  return React.createElement("button", {
              className: Curry._1(Css.merge, {
                    hd: Curry._1(Css.style, {
                          hd: Css.display("flex"),
                          tl: {
                            hd: Css.alignItems("center"),
                            tl: {
                              hd: Css.justifyContent("center"),
                              tl: {
                                hd: Css.flexDirection("column"),
                                tl: {
                                  hd: Css.backgroundColor("transparent"),
                                  tl: {
                                    hd: Css.width(Css.px(40)),
                                    tl: {
                                      hd: Css.height(Css.px(40)),
                                      tl: {
                                        hd: Css.boxSizing("borderBox"),
                                        tl: {
                                          hd: Css.padding("zero"),
                                          tl: {
                                            hd: Css.cursor("pointer"),
                                            tl: {
                                              hd: Css.border(Css.px(2), Css.solid, props.isSelected ? Css.hex(SterlingTokens$LiveRoom.Colors.primaryBlack_nohashtag) : Css.transparent),
                                              tl: /* [] */0
                                            }
                                          }
                                        }
                                      }
                                    }
                                  }
                                }
                              }
                            }
                          }
                        }),
                    tl: {
                      hd: className$1,
                      tl: /* [] */0
                    }
                  }),
              onClick: props.onClick
            }, React.createElement(SterlingIcons$LiveRoom.Collection.MediaPlayCircle24.make, {
                  className: Curry._1(Css.style, {
                        hd: Css.color(Css.hex(SterlingTokens$LiveRoom.Colors.alertRed60_nohashtag)),
                        tl: {
                          hd: Css.transform({
                                NAME: "scale",
                                VAL: [
                                  0.8,
                                  0.8
                                ]
                              }),
                          tl: /* [] */0
                        }
                      })
                }), React.createElement(SterlingTypography$LiveRoom.Caps12Medium.make, {
                  className: Curry._1(Css.style, {
                        hd: Css.fontSize(Css.px(8)),
                        tl: {
                          hd: Css.color(Css.hex(SterlingTokens$LiveRoom.Colors.alertRed60_nohashtag)),
                          tl: {
                            hd: Css.lineHeight(Css.px(12)),
                            tl: /* [] */0
                          }
                        }
                      }),
                  children: Curry._1(match.t, "Common_live")
                }));
}

var make = LiveStreamThumbnail;

export {
  make ,
}
/* Css Not a pure module */
